import { AlertDialog, Button, ButtonGroup } from '@yaradigitallabs/ahua-react';
import type React from 'react';

type DeleteModalProps = {
  open: boolean;
  isDeleting: boolean;
  onDelete: () => void;
  onCancel: () => void;
};

export const DeleteModal: React.FC<DeleteModalProps> = ({
  open,
  isDeleting,
  onDelete,
  onCancel,
}) => {
  return (
    <AlertDialog
      align="center"
      colorConcept="destructive"
      iconSrc="Bang"
      open={open}
      onOpenChange={nextOpen => {
        if (!nextOpen) {
          onCancel();
        }
      }}
      type="icon"
    >
      <AlertDialog.Content>
        <AlertDialog.Start>
          <AlertDialog.Media
            align="center"
            colorConcept="destructive"
            iconSrc="Bang"
            type="icon"
          />
        </AlertDialog.Start>
        <AlertDialog.Middle>
          <AlertDialog.Title align="center">
            Delete production period?
          </AlertDialog.Title>
          <AlertDialog.Description align="center">
            This action cannot be undone.
          </AlertDialog.Description>
        </AlertDialog.Middle>
        <AlertDialog.End>
          <ButtonGroup buttonWidth="block" orientation="vertical" size="s">
            <Button
              onClick={onDelete}
              colorConcept="destructive"
              isLoading={isDeleting}
              loadingPosition="leading"
            >
              Delete
            </Button>
            <Button variant="ghost" onClick={onCancel}>
              Cancel
            </Button>
          </ButtonGroup>
        </AlertDialog.End>
      </AlertDialog.Content>
    </AlertDialog>
  );
};
